/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_RecipientsInputs */



/**
* | output |
* | --- |
* | "Recipients" |
*
* @param {Event_Group_Sync_Property_RecipientsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_recipients = /** @type {((inputs?: Event_Group_Sync_Property_RecipientsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_RecipientsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recipients")
	if (locale === "de") return /** @type {LocalizedString} */ ("Recipients")
	if (locale === "it") return /** @type {LocalizedString} */ ("Recipients")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Recipients")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recipients")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Recipients")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Recipients")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Recipients")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recipients")
	return /** @type {LocalizedString} */ ("Recipients")
});